const STATE = {
  dataRoles: {
    isLoading: false,
    data: null,
  },
};

export default STATE;